import { useState } from "react";
import { TextInput, View, Text } from "react-native";

interface InputProps {
  label: string;
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  secureTextEntry?: boolean;
  keyboardType?: "default" | "email-address" | "numeric" | "number-pad" | "decimal-pad";
  autoCapitalize?: "none" | "sentences" | "words" | "characters";
  blurOnSubmit?: boolean;
  returnKeyType?: "done" | "go" | "next" | "search" | "send";
  onSubmitEditing?: () => void;
  multiline?: boolean;
  numberOfLines?: number;
}

export function Input({ label, value, onChangeText, placeholder, secureTextEntry, keyboardType, autoCapitalize, blurOnSubmit, returnKeyType, onSubmitEditing, multiline, numberOfLines }: InputProps) {
  const [focused, setFocused] = useState(false);

  return (
    <View style={{ marginBottom: 16 }}>
      <Text style={{ fontSize: 14, fontWeight: "500", color: "#374151", marginBottom: 6 }}>{label}</Text>
      <TextInput
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        secureTextEntry={secureTextEntry}
        keyboardType={keyboardType}
        autoCapitalize={autoCapitalize}
        multiline={multiline}
        numberOfLines={multiline ? (numberOfLines ?? 4) : undefined}
        textAlignVertical={multiline ? "top" : undefined}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          borderWidth: 1,
          borderColor: focused ? "#1B2A4A" : "#d1d5db",
          borderRadius: 10,
          paddingVertical: 12,
          paddingHorizontal: 16,
          fontSize: 16,
          backgroundColor: "#fff",
          color: "#1B2A4A",
          minHeight: multiline ? (numberOfLines ?? 4) * 22 + 24 : undefined,
        }}
        placeholderTextColor="#9ca3af"
        blurOnSubmit={blurOnSubmit}
        returnKeyType={returnKeyType}
        onSubmitEditing={onSubmitEditing}
      />
    </View>
  );
}
